<template>
    <div :class="['ima-button', variant, size, fill ]" v-on:click.prevent="act">
        {{title}}
    </div>
</template>

<script>
export default {
    props: {
        act: {
            type: Function,
        },
        title: {
            type: String,
            required: true
        },
        variant: {
          type: String, 
          default: 'primary',
        }, 
        size: {
            type: String,
        },
        fill: {
            type: String,
        }
    }
}
</script>

<style scoped lang="scss">

@use '@/styles/theme.scss';

.ima-button {
    cursor: pointer;
    border-radius: 4px;
    color: theme.$text-white;
    background-color: theme.$primary-color;
    border: none;
    font-weight: 600;
    padding: 12px 24px;
    width: fit-content;
}

.primary {
  background-color: theme.$primary-color;
  color: theme.$text-white;
}
.primary:hover {
    background-color: theme.$primary-color-dark;
}

.secondary {
  color: theme.$text-color;
  background-color: theme.$light-grey-background;
}

.accent {
  color: theme.$primary-color;
  background-color: theme.$secondary-color;
}

.default {
  color: theme.$text-secondary-color;
  background-color: theme.$light-grey-background;
}

.compressed {
    padding: 6px 8px;
}
.smaller {
    padding: 6px 12px;
}
.medium {
    padding: 12px 24px;
}

.clear {
    background-color: transparent;
}

@media (hover: hover) {
    .secondary:hover {
        background-color: theme.$grey-color;
    }
    .accent:hover {
        background-color: theme.$secondary-color-dark;
    }
    .default:hover {
        background-color: theme.$text-grey-light;
    }
}
</style>